import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaHome, FaShoppingBag, FaShoppingCart, FaUser } from "react-icons/fa";
import { useSelector } from "react-redux";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const user = useSelector((state) => state.user?.currentUser);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Hide footer on desktop or cart page
  if (!isMobile || location.pathname === "/cart") return null;

  const activeColor = "#185E37";
  const inactiveColor = "#555"; // grey for inactive

  const footerStyle = {
    position: "fixed",
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTop: "1px solid #ddd",
    boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
    zIndex: 1000,
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: "10px 0",
    maxWidth: "600px",
    margin: "auto",
  };

  const itemStyle = (path) => {
    // Treat "/AuthLogin" and "/dashboard" as account tab
    let isActive;
    if (path === "/AuthLogin") {
      isActive =
        location.pathname === "/AuthLogin" || location.pathname === "/dashboard";
    } else {
      isActive = location.pathname === path;
    }

    return {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: isActive ? activeColor : inactiveColor,
      textDecoration: "none",
      fontSize: "12px",
      transition: "none",
      backgroundColor: "transparent",
      padding: "8px 16px",
      borderRadius: "12px",
      boxShadow: "none",
      position: "relative",
    };
  };

  const activeLineStyle = {
    position: "absolute",
    top: 0,
    width: "40%", // smaller width
    height: "3px", // thin line
    backgroundColor: activeColor,
    borderRadius: "2px",
    left: "50%",
    transform: "translateX(-50%)",
  };

  const iconStyle = {
    fontSize: "20px",
    marginBottom: "4px",
  };

  const handleAccountClick = () => {
    if (user) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  };

  const renderItem = (path, icon, label, onClick) => {
    const isActive =
      path === "/AuthLogin"
        ? location.pathname === "/AuthLogin" || location.pathname === "/dashboard"
        : location.pathname === path;

    return (
      <Link
        to={path}
        style={itemStyle(path)}
        onClick={onClick ? onClick : undefined}
      >
        {isActive && <div style={activeLineStyle}></div>}
        {icon}
        <span>{label}</span>
      </Link>
    );
  };

  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        {renderItem("/", <FaHome style={iconStyle} />, "Home")}
        {renderItem("/allproducts/:categoryid", <FaShoppingBag style={iconStyle} />, "Product")}
        {renderItem(
          user ? "/dashboard" : "/AuthLogin",
          <FaUser style={iconStyle} />,
          "Account"
        )}
        {renderItem("/cart", <FaShoppingCart style={iconStyle} />, "Cart")}
      </div>
    </footer>
  );
};

export default Footer;
